<div fxLayout="column" class="dialog-body">
  <div fxLayout="row" class="dialog-body__header font-size-14 px-24" fxLayoutAlign="space-between center" fxFlex="72px">
    <div fxLayout="column" fxLayoutAlign="center start" *ngIf="data.preview; else viewServerFile">
      <div class="filename text-bold">
        {{ data.preview.fileName }}
      </div>
      <div class="artstuff-promt-text">
        {{ bytesToSize(data.preview.fileSize) }}
      </div>
    </div>
    <ng-template #viewServerFile>
      <div fxLayout="row" fxLayoutAlign="start center">
        <div class="comment__avatar">
          <img class="avatar w-32 h-32" [src]="data.review.author.avatar || 'assets/images/avatars/no-avatar.png'" />
        </div>
        <div fxLayout="column" fxLayoutAlign="center start">
          <div class="filename text-bold">
            {{ data.review.author.userName }}
          </div>
          <div class="artstuff-promt-text">
            <span class="mr-4 text-bold">{{ data.review.fileName }}</span>
            <span class="mr-4">{{ 'AT' | translate }}</span>
            <span class="">{{ data.review.attachmentTime | date: 'HH:mm dd/MM/YYYY' }}</span>
          </div>
        </div>
      </div>
    </ng-template>
    <button mat-icon-button class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div fxLayout="row" fxFill class="my-28 dialog-body__content">
    <div class="w-80-p" fxLayout="column" fxLayoutAlign="center center">
      <span *ngIf="canDisplay; else notSupport" class="h-100-p">
        <img [src]="data.review.displayUrl | showImg | async" alt="preview image" *ngIf="data.review" />
        <img [src]="data.preview.file | showImg | async" alt="preview image" *ngIf="data.preview" />
      </span>
      <ng-template #notSupport>
        <mat-icon class="s-60 mt-44 mb-24" svgIcon="artstuff_not_support_display"></mat-icon>
        <span *ngIf="!data.preview" class="text-semibold artstuff-promt-text mb-48">{{ 'NOT_SUPPORT' | translate }}</span>
        <span *ngIf="data.preview" class="text-semibold artstuff-promt-text mb-48">{{ 'NOT_SUPPORT_WHEN_TYPING' | translate }}</span>
      </ng-template>
    </div>

    <div class="dialog-body__icon">
      <mat-icon
        class="s-20 artstuff-pointer"
        (click)="removeFile()"
        matTooltip="{{ 'REMOVE' | translate }}"
        *ngIf="data.preview; else downloadFile"
        >delete</mat-icon
      >

      <ng-template #downloadFile>
        <mat-icon
          class="s-20 artstuff-pointer"
          matTooltip="{{ 'DOWNLOAD' | translate }}"
          svgIcon="artstuff_download"
          (click)="downloadAttachment()"
        ></mat-icon>
      </ng-template>
    </div>
  </div>
</div>
